import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import SongEditPage from "./SongEditPage";

// Catalog's "Add song" button passes directToCatalog via router state
// (see Catalog.jsx) - everywhere else (Song Proposals' "Add new")
// proposes normally, defaulting to pending on the backend.
export default () => {
  const history = useHistory();
  const location = useLocation();
  const directToCatalog = !!(location.state && location.state.directToCatalog);
  // Set by ShareTarget when this song was proposed via the OS share
  // sheet (sharing a YouTube video or a Spotify track straight into the
  // app) - pre-fills the link so SongEditPage's own autofill
  // (runYoutubeLookup/runSpotifyLookup) picks up title/artist the same
  // way it would for a manually pasted link.
  const youtubeLink = (location.state && location.state.youtubeLink) || "";
  // Bare id, not a link - matches the shape an existing song's own
  // spotify_id already has (see SongEditPage's init, which wraps
  // whatever's passed here into a canonical spotify:track:<id> value).
  const spotifyId = (location.state && location.state.spotifyId) || "";

  const goToNewSong = (saved) => history.push(`/songs/${saved.id}`);
  const goBack = () => history.push((location.state && location.state.from) || "/catalog");

  return (
    <SongEditPage
      song={{ id: null, title: "", artist: "", youtube_link: youtubeLink, spotify_id: spotifyId, lyrics: "" }}
      directToCatalog={directToCatalog}
      onSaved={goToNewSong}
      onCancel={goBack}
    />
  );
};
